import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the Nl2LiPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'nl2Li',
})
export class Nl2LiPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return (value?value:'').split("\n").map(row => {
      return '<li>'+row+'</li>';
    }).join('');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/nl2-li/nl2-li.ts